import { AccountCircle } from "@mui/icons-material";
import { IconButton, Tooltip, Zoom } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { NAV_ROUTES } from "components/NavigationBar";

export function UserAccountButton() {
  const navigate = useNavigate();

  return (
    <Tooltip title="Account" placement="bottom" TransitionComponent={Zoom}>
      <IconButton color="inherit" onClick={() => navigate(NAV_ROUTES.ACCOUNT)}>
        <AccountCircle fontSize="large" />
      </IconButton>
    </Tooltip>
  );
}
